// src/modules/app-views/crm/pages/Document/modals/RescheduleModal/Step1.jsx
// *******************************************************************************
// RESCHEDULE MODAL - STEP 1
// *******************************************************************************
// Date/time picker + optional note for rescheduling a CRM opportunity
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, DatePicker, Form, Input, Row, TimePicker } from 'antd';
import translateX from 'utils/translateX';
import dayjs from 'dayjs';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step1 = () => {
  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="date"
            label={translateX('date')}
            rules={[{ required: true, message: () => translateX('required_field') }]}
          >
            <DatePicker
              className="w-100"
              format="DD/MM/YYYY"
              disabledDate={current => current && current.isBefore(dayjs(), 'day')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="time"
            label={translateX('time')}
            rules={[{ required: true, message: () => translateX('required_field') }]}
          >
            <TimePicker className="w-100" format="HH:mm" minuteStep={5} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="note" label={translateX('notes')}>
        <Input.TextArea
          rows={3}
          maxLength={300}
          showCount
          placeholder={translateX('reschedule_notes_hint')}
        />
      </Form.Item>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1;
